import FirebaseDatabaseService from "../FirebaseDatabseService";

export default class FirestoreObserver<T> {
  private _unsubscribe: () => void;
  private paths: string[];

  constructor(paths: string[]) {
    this.paths = paths;
  }

  public subscribe(onUpdate: (data: T) => void) {
    this._unsubscribe = FirebaseDatabaseService.getObjectUpdates(
      this.paths,
      onUpdate,
      this.onError
    );
  }

  public unsubscribe() {
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  }

  private onError = (error: Error) => {
    console.error(`Failed observing ${this.paths.join("/")}`);
  };
}



// WEBPACK FOOTER //
// ./src/services/firebase/database/observers/FirestoreObserver.ts